import styles from "./DateInput.module.scss";

export const DateInput = ({id, max, min, className = "", isError, errorMsg, withoutBorder, ...rest}) => {
  return (
    <>
      <input
        type="date"
        max={max}
        min={min}
        id={id}
        className={`form-control py-2 px-3 ${styles.input} ${className} ${isError ? styles.error : ""} ${
          withoutBorder ? styles.withoutBorder : ""
        }`}
        {...rest}
      />

      {isError && <div className={styles.errorMsg}>{errorMsg}</div>}
    </>
  );
};
